import { Refresh } from "@mui/icons-material";
import { useQueryClient } from "@tanstack/react-query";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";

export function RefreshAllButton() {
  const queryClient = useQueryClient();
  return (
    <AsyncLoadingButton
      color="inherit"
      style={{ borderRadius: 32, width: 38, borderColor: "rgba(255,255,255,0.15)" }}
      onClick={async () => {
        await queryClient.resetQueries({ predicate: () => true });
      }}
      title="Odśwież dane"
    >
      <Refresh />
    </AsyncLoadingButton>
  );
}
